import io from 'socket.io-client';

const socket = io.connect(process.env.VUE_APP_BASE_URL);

export default socket